// The primary-bar dropdowns are CSS-only: a topic's flyout shows on
// :hover / :focus-within (see scss/components/_site-navbar-dropdown.scss).
// The :focus-within half is what keeps them keyboard-reachable, but it has a
// mouse-user failure mode: clicking a child link focuses it, and when the
// visitor comes back (bfcache or a normal back navigation) the browser
// restores that focus, so the panel sits open and hovering another topic just
// opens a second one beside it. Nothing closes it until something else takes
// focus. These two listeners release stale focus so hover behaves as expected.
const NAV = '.site-navbar--primary';
const PARENT = `${NAV} .site-navbar__item--with-children`;

const focusedInNav = () => {
  const el = document.activeElement;
  return el && el.closest && el.closest(NAV) ? el : null;
};

export default () => {
  if (typeof document === 'undefined') return;

  // Back/forward restores focus to the link that was clicked.
  window.addEventListener('pageshow', () => {
    const el = focusedInNav();
    if (el) el.blur();
  });

  // Hovering a different topic while a focused one is pinned open.
  document.addEventListener('mouseover', (event) => {
    const li = event.target.closest && event.target.closest(PARENT);
    if (!li) return;
    const el = focusedInNav();
    if (el && !li.contains(el)) el.blur();
  });
};
